import * as React from 'react'
import { GridColumns } from '@mui/x-data-grid'
import { Avatar, Box, Checkbox, Typography } from '@mui/material'
import Iconify from 'components/Iconify'
import { translate as t } from '../../../i18n'

export const ColumnsToAssign: GridColumns = [
  {
    field: 'image',
    headerName: '',
    flex: 0.7,
    renderCell: () => {
      return <Box sx={{ display: 'flex', textAlign: 'left', flexDirection: 'row' }}>
        <Box padding-left="0px" sx={{ display: 'flex', flexDirection: 'column', textAlign: 'left' }}>
          <Avatar variant="rounded" sx={{ bgcolor: '#D6500D', width: '60px', height: '60px' }}>
            <Iconify color="#FFF" icon="arcticons:home-workouts" width="40px"></Iconify>
          </Avatar>
        </Box>
      </Box>
    },
    editable: true
  },
  {
    field: 'name',
    renderHeader: () => (t('routine.gridColumns.routine')),
    flex: 2,
    valueGetter: (params) => params.row.name,
    renderCell: (params) => {
      return <Typography variant="subtitle2" sx={{ textTransform: 'uppercase' }}>
        {params?.row?.name}
      </Typography>
    },
    editable: true
  },
  {
    field: 'note',
    renderHeader: () => (t('routine.gridColumns.note')),
    valueGetter: (params) => params?.row?.note,
    flex: 2,
    editable: true,
    renderCell: (params) => {
      return <Typography variant="subtitle2" sx={{ textTransform: 'uppercase' }}>
        {params?.row?.note}
      </Typography>
    }
  },
  {
    field: 'level',
    renderHeader: () => (t('routine.gridColumns.level')),
    flex: 0.8,
    valueGetter: (params) => params?.row?.level,
    editable: false
  },
  {
    field: 'startedAt',
    renderHeader: () => (t('routine.gridColumns.startedAt')),
    flex: 0.8,
    valueGetter: (params) => (params.row.startedAt = new Date()),
    editable: true,
    type: 'date'
  },
  {
    field: 'dueDateAt',
    renderHeader: () => (t('routine.gridColumns.dueDateAt')),
    editable: true,
    flex: 0.8,
    type: 'date'
  },
  {
    field: 'visibleAfterDueDate',
    renderHeader: () => (t('routine.gridColumns.visibleAfterDueDate')),
    valueGetter: (params) => params.row.visibleAfterDueDate,
    renderCell: (params) => (<Checkbox onChange={event => { params.row.visibleAfterDueDate = (event.target.checked) }}/>),
    type: 'boolean',
    flex: 1.2
  }
]
